import builder from '../builder';
import FolderFile from '../../streamline-icons/light/folder-file.svg';

export default builder('FolderFileLight', FolderFile);
